export const transformAttribute = (condition: boolean | string): string => (condition ? 'true' : '');
